<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input-facade
      v-model="inputValue"
      :id="inputId"
      :mask="getDocumentMask"
      :placeholder="documentHint"
      :disabled="disabled"
      maxlength="12"
      class="form-control text-uppercase"
      masked
      @change="emitValue('change', $event)"
      @input="emitValue('input', $event)"
      @blur="emitValue('blur', $event)"
      @keydown="emit"
      @keyup="emit"
    />
    <div v-if="visitor.personal.innControlSumErr" class="form-fielderror trailer-error">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Контрольные суммы не совпадают. Введите правильный ИНН.</div>
      </div>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorInnInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'ИНН'
    },

    inputName: {
      default: 'inn'
    },

    inputHint: {
      default: undefined
    },

    subjectResidency: {
      type: Object,
      required: true
    }
  },

  computed: {
    inputId () {
      return `form-visitor-inn-${this.visitorIndex}`
    },

    documentHint () {
      return this.subjectResidency?.hint ?? ''
    },

    getDocumentMask () {
      return this.subjectResidency?.mask ? JSON.parse(this.subjectResidency?.mask) : 'XXXXXXXXXXXXXXXX'
    }
  }
}
</script>
